type Props = { name: any; value: string };

const NameAndValue = ({ name, value }: Props) => {
  return (
    <div className="flex items-center gap-1 px-1 py-1 text-xs text-center">
      <span className="!font-normal capitalize flex items-center">{name}</span>
      <span className="text-color-primary 2xl:mx-1 !font-[600] capitalize flex items-center whitespace-nowrap">
        {value}
      </span>
    </div>
  );
};

export default NameAndValue;
